<template>

  <!-- div class="text-slate-400 text-xs">
    {{ question }}
  </div -->

  <Transition>
  <div v-if="question.open" class="w-full bg-light-blue py-12 px-6 text-center rounded-xl">
    <div class="text-dark-blue font-bold">{{ question.name }}</div>

    <div class="flex flex-col gap-6 md:flex-row items-center md:gap-12 justify-center mt-6">
      <div v-for="option in question.options"
           class="px-6 py-2 bg-blue-900 text-white rounded-xl cursor-pointer hover:bg-orange"
           :class="question.option_selected == option ? 'bg-orange': ''"
           @click="$emit('select', question, option)"
      >
        {{ option.name }}
      </div>
    </div>
  </div>
  </Transition>

  <Transition>
  <div v-if="!question.open" @click="$emit('open', question)" class="cursor-pointer w-full bg-orange text-white py-4 px-6 text-center rounded-xl flex flex-row items-center justify-center gap-4">
    <div>{{ question.name }}</div>
    <div class="font-bold min-w-[30%]">{{ question.option_selected ? question.option_selected.name : ''}}</div>
  </div>
  </Transition>

</template>

<script>
export default {
  emits: ['select', 'open'],
  props: {
    question: {
      required: true
    }
  }
}
</script>

<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
